import { IOfferSpendByOfferDetailsTableLang } from '../../../types/lang'

export const offerSpendByOfferDetailsTableLang: IOfferSpendByOfferDetailsTableLang = {
	offer_spend_by_offer_details_table: {
		column_id: 'ID_ua',
		column_date: 'Date_ua',
		column_amount: 'Amount_ua',
		column_account: 'Account_ua',
		column_kt_group: 'KT Group_ua',
		column_notes: 'Notes_ua',
	}
}